import { render, staticRenderFns } from "./DiffPeiceFeedback.vue?vue&type=template&id=85ca13d2&scoped=true&"
import script from "./DiffPeiceFeedback.vue?vue&type=script&lang=js&"
export * from "./DiffPeiceFeedback.vue?vue&type=script&lang=js&"
import style0 from "./DiffPeiceFeedback.vue?vue&type=style&index=0&id=85ca13d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ca13d2",
  null
  
)

export default component.exports